/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import styled from 'styled-components'

import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Globals, ContentGrid, Column } from 'components/base'
import { ChartKey } from 'components/base/ChartKey'
import { Filters } from 'components/Filters'
import { GroupTitle } from 'components/GroupTitle'
import { csvParse, autoType } from 'd3-dsv'
import { CardGrid } from 'components/CardGrid'
import { LastCheck } from 'components/LastCheck'
import Content_de from './content_de'
import Content_fr from './content_fr'
window.dataLayer = window.dataLayer || []
const isMobile = window.innerWidth < 712

const locale: 'de' | 'fr' = 'de'

const ARTICLE_ID_DE = '646626677000'
const ARTICLE_ID_FR = '522691488967'
const ARTICLE_ID = locale === 'fr' ? ARTICLE_ID_FR : ARTICLE_ID_DE

export const trackEvent = (ev: {
  event_label?: string | number
  even_info?: string
}) => {
  const track = {
    ...ev,
    ...{
      event: 'Interactions',
      event_action: 'click',
      article_id: ARTICLE_ID
    }
  }
  if (window.dataLayer) window.dataLayer.push(track as any)
}
// TODO Set the correct article ID here

const Lables_de = require('./labels_de.json')
const Lables_fr = require('./labels_fr.json')
const LABELS = locale === 'fr' ? Lables_fr : Lables_de
const CONTENT = locale === 'fr' ? Content_fr : Content_de
export function AppComponent() {
  const [checkDate, setCheckDate] = useState<Date | undefined>()
  const [fulldata, setfulldata] = useState<FruitElementType[] | null>()
  const [fruitdata, setfruitdata] = useState<FruitElementType[] | null>()
  const [fruitsbyseason, setfruitsbyseason] = useState<FruitElementType[][]>()
  const [filters, setfilters] = useState<Partial<newFiltersType>>({
    availability: 'all',
    type: 'all',
    durability: 'all',
    usage: ['raw', 'cook', 'fry', 'steam', 'bake', 'waehe', 'compott'],
    lastCheckDate: undefined,
    selectedDay: new Date(),
    selectedWeek: getWeek(new Date())
  })
  useEffect(() => {
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/obst-und-gemuesekalender/data.csv'
    )
      .then(a => a.text())
      .then(a => {
        let full = csvParse(a, autoType).map(
          (element: { [key: string]: any }) => {
            for (let p in element) {
              if (!element[p]) element[p] = false
            }
            if (locale === 'fr') {
              element.bez = element.bez_fr
              element.bez_alternativ = element.bez_alternativ_fr
              element.verw_alt_text = element.verw_alt_text_fr
            }
            return element
          }
        )
        const dates = full
          .map(m => (m.checked ? new Date(m.checked) : undefined))
          .filter(f => f)
        if (dates[0]) {
          setCheckDate(dates[0])
          setfilters({ ...filters, lastCheckDate: dates[0] })
        }
        console.log(full)

        setfulldata(full as FruitElementType[])
        setfruitdata(full as FruitElementType[])
      })
  }, [])

  useEffect(() => {
    if (!fruitdata) return
    let week = filters.selectedWeek
    const sortByChecked = (a, b) =>
      a.checked && a.checkedAndAvailable
        ? b.checked && b.checkedAndAvailable
          ? 1
          : -1
        : 1
    let hasSeason = fruitdata
      .filter(f => {
        if (week === getWeek(new Date()) && f.checked && f.checkedAndAvailable)
          return true

  
          

        if (+f.normfrom < +f.normto && week) {
          if (+f.normfrom <= week && week <= +f.normto) return true
        }

        if (+f.normfrom > +f.normto && week) {
          if (+f.normto <= week && week >= +f.normto) return true
        }
        return false
      })
      .sort(sortByChecked)
      .map(m => {
        m.hasSeason = true
        m.activeColor = week === getWeek(new Date())
        return m
      })
    let hasNoSeason = fruitdata
      .filter(f => !hasSeason.includes(f))
      .sort(sortByChecked)
      .map(m => {
        m.hasSeason = false
        return m
      })
    setfruitsbyseason([hasSeason, hasNoSeason])
  }, [fruitdata, filters.selectedWeek])

  useEffect(() => {
    if (!fulldata) return

    const propsToSkip = ['lastCheckDate']
    const filtervalues = Object.entries(filters).filter(
      f => propsToSkip.indexOf(f[0]) === -1
    )

    let filtered = JSON.parse(JSON.stringify(fulldata))
    filtervalues.map(obj => {
      const [key, value] = obj

      if (key === 'type') {
        if (value !== 'all') {
          filtered = filtered.filter(f => f[value as string])
        }
      }
      if (key === 'availability') {
        if (value !== 'all') {
          filtered = filtered.filter(f => f[value as string])
        }
      }
      if (key === 'durability') {
        if (value !== 'all') {
          let allFitting =
            (value as string) === '3days'
              ? ['upto3', 'upto7', 'upto14']
              : (value as string) === '1week'
              ? ['upto7', 'upto14']
              : ['upto14']
          filtered = filtered.filter(f => {
            let keep = false
            allFitting.map(m => {
              if (f[m] === true) keep = f[m] === true
            })

            return keep
          })
        }
      }
      if (key === 'usage') {
        const maptodataprops: { [key: string]: string } = {
          raw: 'roh',
          fry: 'braten',
          steam: 'duensten',
          bake: 'backen',
          waehe: 'waehe',
          compott: 'kompott',
          cook: 'kochen'
        }
        filtered = filtered.filter(f => {
          let keep = false
          ;(value as string[]).map(m => {
            if (f[maptodataprops[m]] === true) keep = true
          })

          return keep
        })
      }
    })
    setfruitdata(filtered)
  }, [filters.type, filters.availability, filters.usage, filters.durability])

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} inverted />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'></div>
      </header>
      <div className='ui header title'>
        <div className='ui  container'>
          <h1>{LABELS.Main.title} </h1>
          <h2>{LABELS.Main.lead}</h2>
          <p>
            <div className='ta author'>
              Daniel Böniger, Katrin Nidzwetzki, Sebastian Broschinski
            </div>
            <div className='ta updated' style={{ marginBottom: '30px' }}>
              {LABELS.Main.updated}
            </div>
          </p>
        </div>
      </div>

      <Globals>
        <ContentGrid>
          <Column style={{ textAlign: 'center' }}>
            {filters.lastCheckDate && (
              <LastCheck
                date={new Date(filters.lastCheckDate).toLocaleDateString(
                  locale + '-CH',
                  {
                    day: 'numeric',
                    month: 'long'
                  }
                )}
                labels={LABELS.checkinfo}
              >
                {CONTENT.checkinfo}
              </LastCheck>
            )}
          </Column>

          <Column>
            <Filters
              checkDate={checkDate}
              setFilters={setfilters}
              labels={LABELS.Filters}
              locale={locale}
            />
          </Column>
        </ContentGrid>

        <ContentGrid>
          <Column>
            <GroupTitle
              week={filters.selectedWeek}
              lang={locale}
              labels={LABELS.grouptitle}
            >
              {LABELS.season[0]}
            </GroupTitle>
            {filters.selectedWeek === getWeek(new Date()) && (
              <ChartKey
                labels={LABELS.callToAction}
                entries={[
                  {
                    type: 'color',
                    color: '#D1E3D7',
                    size: 15,
                    label: LABELS.chartkey[0]
                  },
                  {
                    type: 'color',
                    color: '#EFECE0',
                    size: 15,
                    label: LABELS.chartkey[1]
                  }
                ]}
              />
            )}
            {!fruitsbyseason && (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <Loader>
                  <div></div>
                  <div></div>
                </Loader>
              </div>
            )}
            {fruitsbyseason && fruitsbyseason[0] && (
              <CardGrid
                data={fruitsbyseason[0]}
                showAll
                labels={LABELS.Cards}
                lang={locale}
              />
            )}
          </Column>

          <Column>
            <GroupTitle lang={locale} labels={LABELS.grouptitle}>
              {LABELS.season[1]}
            </GroupTitle>
            {!fruitsbyseason && (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <Loader>
                  <div></div>
                  <div></div>
                </Loader>
              </div>
            )}
            {fruitsbyseason && fruitsbyseason[1] && (
              <CardGrid
                data={fruitsbyseason[1]}
                labels={LABELS.Cards}
                lang={locale}
              />
            )}
          </Column>
        </ContentGrid>
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta text'>{CONTENT.text}</div>
          </div>
        </div>
        <Footer
          mailTo='interactif@tamedia.ch'
          locale={locale}
          hidePortfolioTeaser
          articleId={ARTICLE_ID}
          credits={[
            [LABELS.Main.credits[0], 'Daniel Böniger'],
            [LABELS.Main.credits[1], 'Katrin Nidzwetzki'],
            [LABELS.Main.credits[2], 'Sebastian Broschinski'],
            [LABELS.Main.credits[3], 'Katrin Nidzwetzki']
          ]}
          questions={LABELS.Questions}
        />
      </Globals>
    </div>
  )
}
const Loader = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  div {
    position: absolute;
    border: 4px solid var(--brandblue-bright-2);
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 0;
    }
    4.9% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 0;
    }
    5% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }
`
export const getWeek = (date: string | Date) => {
  var d = new Date(new Date(date).getTime())
  d.setHours(0, 0, 0, 0)
  // Thursday in current week decides the year.
  d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7))
  // January 4 is always in week 1.
  var week1 = new Date(d.getFullYear(), 0, 4)
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  return (
    1 +
    Math.round(
      ((d.getTime() - week1.getTime()) / 86400000 -
        3 +
        ((week1.getDay() + 6) % 7)) /
        7
    )
  )
}
export const intDateFromDate = (date: string | Date) => {
  return new Date(date).toISOString().split('T')[0]
}
export const daysIntoYear = (date: Date) =>
  (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) -
    Date.UTC(date.getFullYear(), 0, 0)) *
  (1 / 86400000)
export const dateFromDay = (year: number, day: number, locale: 'de' | 'fr') => {
  var date = new Date(new Date(year, 0).setDate(day)) // initialize a date in `year-01-01`
  return [
    date.toISOString().split('T')[0],
    date.toLocaleDateString(locale + '-CH', {
      day: 'numeric',
      month: 'long'
    })
  ] // add the number of days
}

export const weekToDate = (year: number, week: number, weekDay = 0) => {
  const getZeroBasedIsoWeekDay = (date: Date) => (date.getDay() + 6) % 7
  const getIsoWeekDay = (date: Date) => getZeroBasedIsoWeekDay(date) + 1
  const zeroBasedWeek = week - 1
  const zeroBasedWeekDay = weekDay - 1
  let days = zeroBasedWeek * 7 + zeroBasedWeekDay
  // Dates start at 2017-01-01 and not 2017-01-00
  days += 1

  const firstDayOfYear = new Date(year, 0, 1)
  const firstIsoWeekDay = getIsoWeekDay(firstDayOfYear)
  const zeroBasedFirstIsoWeekDay = getZeroBasedIsoWeekDay(firstDayOfYear)

  // If year begins with W52 or W53
  if (firstIsoWeekDay > 4) {
    days += 8 - firstIsoWeekDay
    // Else begins with W01
  } else {
    days -= zeroBasedFirstIsoWeekDay
  }

  return new Date(year, 0, days)
}

export const monthnamesShort = [
  'J',
  'F',
  'M',
  'A',
  'M',
  'J',
  'J',
  'A',
  'S',
  'O',
  'N',
  'D'
]
export const monthnames = [
  'Jan',
  'Feb',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'Aug',
  'Sep',
  'Okt',
  'Nov',
  'Dez'
]
export const monthnameslong = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember'
]
